export const setSessionId = (sessionId)=>({
    type : 'SET_SESSION_ID',
    payload : sessionId
})
export const setUser = (setUser)=>({
    type : 'SET_USER',
    payload : setUser
})
export const setUserPhoto = (setUserPhoto)=>({
    type : 'SET_USER_PHOTO',
    payload : setUserPhoto
})
export const setUserId = (setUserId)=>({
    type : 'SET_USER_ID',
    payload : setUserId
})
export const setUserName = (setUserName)=>({
    type : 'SET_USER_NAME',
    payload : setUserName
})
export const setIsAdmin = (isAdmin)=>({
    type : 'SET_IS_ADMIN',
    payload : isAdmin
})
export const clearSession = () => ({
    type: 'CLEAR_SESSION',
});
